import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PhysicalSystemComponentModel } from 'src/app/data-models/PhysicalSystemComponent';

@Component({
  selector: 'app-hw-addons',
  templateUrl: './hw-addons.component.html'
})
export class HwAddonsComponent {
  @Output()
  openHelpModal: EventEmitter<any> = new EventEmitter();

  isThisSectionVisible = false;

  thirdPartyHwAddonsFromPCS7Bom: PhysicalSystemComponentModel[] = [];
  thirdPartyHwAddonsFromPcsNeoBom: PhysicalSystemComponentModel[] = [];

  tabHeadings: string[] = [];

  async toggleVisibilityForIdentifiedHWAddons() {
    await this.fillThirdPartyHwComponentsList();
    this.isThisSectionVisible = !this.isThisSectionVisible;
  }

  async fillThirdPartyHwComponentsList() {
    this.thirdPartyHwAddonsFromPCS7Bom = [];
    this.thirdPartyHwAddonsFromPcsNeoBom = [];

    const relevantThirdPartyHWComponentTypes: string[] = ['3-Party HW Addons'];

    for (let i = 1; i <= 200; i++) {
      if (this.isPhysicalSystemComponentPresent(i, 'PCS 7')) {
        console.log(i);
        const componentType = this.parentForm.get('hwAddons')?.get('physicalSystemComponentType' + i)?.value;

        if (relevantThirdPartyHWComponentTypes.includes(componentType)) {
          this.thirdPartyHwAddonsFromPCS7Bom.push({
            componentNumber: i,
            componentType: this.parentForm.get('hwAddons')?.get('physicalSystemComponentType' + i)?.value,
            mlfb: this.parentForm.get('hwAddons')?.get('physicalSystemMlfb' + i)?.value,
            quantity: this.parentForm.get('hwAddons')?.get('physicalSystemQuantity' + i)?.value,
            listPrice: this.parentForm.get('hwAddons')?.get('physicalSystemPrice' + i)?.value,
            description: this.parentForm.get('hwAddons')?.get('physicalSystemDesc' + i)?.value,
            gck: this.parentForm.get('hwAddons')?.get('physicalSystemGCK' + i)?.value
          });
        }
      }

      if (this.isPhysicalSystemComponentPresent(i, 'PCS neo')) {
        const componentType = this.parentForm.get('hwAddons')?.get('physicalSystemNeoComponentType' + i)?.value;

        if (relevantThirdPartyHWComponentTypes.includes(componentType)) {
          this.thirdPartyHwAddonsFromPcsNeoBom.push({
            componentNumber: i,
            componentType: this.parentForm.get('hwAddons')?.get('physicalSystemNeoComponentType' + i)?.value,
            mlfb: this.parentForm.get('hwAddons')?.get('physicalSystemNeoMlfb' + i)?.value,
            quantity: this.parentForm.get('hwAddons')?.get('physicalSystemNeoQuantity' + i)?.value,
            listPrice: this.parentForm.get('hwAddons')?.get('physicalSystemNeoPrice' + i)?.value,
            description: this.parentForm.get('hwAddons')?.get('physicalSystemNeoDesc' + i)?.value,
            gck: this.parentForm.get('hwAddons')?.get('physicalSystemNeoGCK' + i)?.value
          });
        }
      }
    }
  }

  isPhysicalSystemComponentPresent(compNumber: number, pcsVersion: string): boolean {
    let componentTypeVarName = '';
    if (pcsVersion === 'PCS neo') {
      componentTypeVarName = 'physicalSystemNeoComponentType';
    } else {
      componentTypeVarName = 'physicalSystemComponentType';
    }

    try {
      if (this.parentForm.get('hwAddons')?.get(componentTypeVarName + compNumber)?.value) {
        return true;
      } else {
        return false;
      }
    } catch {
      return false;
    }
  }

  getHwAddonTabName(index: number): string {
    return this.parentForm.get('hwAddons')?.get('hwAddonsTabName' + (index + 1))?.value || `HW Addon ${index + 1}`;
  }

  @Input()
  parentForm!: FormGroup;

  constructor() {}
}
